import React from "react";
import styles from "../../reusable/servicesHome/servicesHome.module.scss";
import bgVideo from "../../../assests/videos/domainBgVideo.gif";
import { useNavigate } from "react-router-dom";

const ServicesHome = (props) => {
  const myData = props.data;
  const navigate = useNavigate();

  function navigateSignin() {
    navigate("/login");
  }

  return (
    <>
      {myData.map((event, index) => (
        <div className={styles.container} key={index}>
          <div className={styles.wrapper}>
            <img
              autoPlay
              muted
              loop
              className={styles.video}
              src={bgVideo}
              alt="Background"
            />
            <div className={styles.domainContent}>
              <div className={styles.title}> {event.heading}</div>
              <div className={styles.description}>{event.description}</div>
              <div className={styles.demoBtn} onClick={navigateSignin}>
                Sign in for Free Demo
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ServicesHome;
